import React from "react";
import "./customswitch.scss";
const CustomSwitch = ({
  isOn,
  handleToggle,
  onColor,
  switchOn,
  switchOff,
  section,
}) => {
  return (
    <label
      style={{
        background: (isOn && onColor) || (section === "PYF" && onColor),
      }}
      className="react-switch"
    >
      <input
        checked={isOn}
        onChange={handleToggle}
        className="react-switch-checkbox"
        type="checkbox"
      />
      <div className={`react-switch-button ${isOn ? "checked" : ""}`} />
      <div className="react-switch-labels">
        <span>{switchOn}</span>
        <span>{switchOff}</span>
      </div>
    </label>
  );
};

export default CustomSwitch;
